export const not64 = (a) => [~a[0], ~a[1]];
